/*
  JILZARAH — World of Color stocking page (custom, not part of Flex)

  Progressive enhancement for sections/jilzarah-woc.liquid. Reads the config and product
  JSON the section renders and drives a single side drawer in three modes — a product
  detail, the four styles, or the refill builder. Nothing here navigates away from the page.

  The cart: there is no assortment of its own any more. Every stepper writes straight to
  the Shopify cart through window.JZCart (assets/jilzarah-cart.js) and every quantity,
  piece count on the page is read back from it. Nothing opens on its own: an "Add" turns the
  button into a stepper, the header count ticks up and a small toast confirms it with a
  "View cart" link; +/- just update the count. There is no page-side summary of the cart.

  Prices: the product JSON carries a price only for a signed-in customer (Liquid gate).
  When it is absent the script never prints one and every Add becomes "Login to order".

  Stock: kits and packs are untracked (stock null, always orderable, never claimed "in
  stock"); tracked keychains are capped at the largest multiple that fits. If the cart
  still refuses a quantity, the module re-reads the cart and the page snaps back to it.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.wocReady) return;
    root.dataset.wocReady = '1';

    var signedIn = root.dataset.signedIn === 'true';
    var LOGIN = root.dataset.loginUrl || '/account/login';
    var CART = window.JZCart; if (!CART) return;

    /* ---------- data ---------- */
    var cfgEl = root.querySelector('[data-woc-config]');
    var C = cfgEl ? JSON.parse(cfgEl.textContent) : { colors: [], swatches: {}, formats: [], labels: {} };
    var L = C.labels || {};
    var P = {};
    root.querySelectorAll('[data-woc-product]').forEach(function (el) {
      var p; try { p = JSON.parse(el.textContent); } catch (e) { return; }
      if (!p.sku) return;
      p.tags = p.tags || []; p.images = p.images && p.images.length ? p.images : [{ src: p.image || p.thumb, alt: '' }];
      P[p.sku] = p;
    });
    if (!Object.keys(P).some(function (k) { return typeof P[k].price === 'number'; })) signedIn = false;

    var COLORS = (C.colors || []).map(function (n) { return { key: n, sw: (C.swatches && C.swatches[n]) || ['#6d6064'] }; });
    var FORMATS = (C.formats || []).filter(function (f) { return f.tag; });
    var GROUPS = [['kit', 'Displays and restock kits'], ['pack', 'Variety packs'], ['single', 'Individual keychains']];

    var byCell = {}, fmtOf = {};
    Object.keys(P).forEach(function (sku) {
      var p = P[sku]; if (p.kind !== 'single') return;
      FORMATS.forEach(function (f) { if (p.tags.indexOf(f.tag) > -1 && !fmtOf[sku]) fmtOf[sku] = f; });
      COLORS.forEach(function (c) {
        if (p.tags.indexOf(c.key) < 0) return;
        FORMATS.forEach(function (f) { if (p.tags.indexOf(f.tag) > -1 && !byCell[c.key + '|' + f.tag]) byCell[c.key + '|' + f.tag] = sku; });
      });
    });
    FORMATS.forEach(function (f) { if (f.pack && P[f.pack]) fmtOf[f.pack] = f; });
    var find = function (color, fmt) { return byCell[color + '|' + fmt] || null; };

    /* ---------- helpers ---------- */
    var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var chip = function (sw, sm) { return '<span class="woc-chip' + (sm ? ' woc-chip--sm' : '') + '">' + sw.map(function (c) { return '<i style="background:' + esc(c) + '"></i>'; }).join('') + '</span>'; };
    var img = function (sku, alt) { var p = P[sku]; return p && p.thumb ? '<img src="' + esc(p.image || p.thumb) + '" alt="' + esc(alt || p.title) + '" loading="lazy">' : ''; };
    var live = root.querySelector('[data-woc-live]');
    var say = function (t) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 30); };
    var priceOf = function (sku) { var p = P[sku]; return signedIn && typeof p.price === 'number' ? money(p.price) : '&mdash;'; };
    var toastEl = root.querySelector('[data-woc-toast]'), toastT = null;
    function toast(html, ms) { if (!toastEl) return; toastEl.innerHTML = html; toastEl.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, ms || 5000); }
    var cartLink = ' <a href="/cart" data-woc-cart>View cart</a>';

    /* ---------- availability (one rule set, every surface) ---------- */
    function of(sku) {
      var p = P[sku]; if (!p) return { state: 'hidden', max: 0, label: '' };
      var ov = p.override || 'automatic';
      if (ov === 'hidden') return { state: 'hidden', max: 0, label: '' };
      if (ov === 'temporarily_unavailable' || ov === 'unavailable') return { state: 'unavailable', max: 0, label: 'Temporarily unavailable' };
      if (!p.available && p.tracked) return { state: 'oos', max: 0, label: 'Out of stock' };
      if (!p.tracked) return { state: 'untracked', max: Infinity, label: '' };
      if (String(p.policy).toUpperCase() === 'CONTINUE') return { state: 'ok', max: Infinity, label: '' };
      var s = Math.max(0, p.stock || 0);
      var max = p.kind === 'single' ? Math.floor(s / p.mult) * p.mult : s;
      var floor = p.kind === 'single' ? Math.max(p.min, p.mult) : 1;
      if (max < floor) return { state: 'oos', max: 0, label: 'Out of stock' };
      if (max <= floor * 5) return { state: 'low', max: max, label: 'Only ' + max + ' left' };
      return { state: 'ok', max: max, label: '' };
    }
    var sellable = function (sku) { var a = of(sku); return a.state !== 'oos' && a.state !== 'unavailable' && a.state !== 'hidden'; };

    /* ---------- quantities: the Shopify cart is the only cart ---------- */
    var Q = function (sku) { var p = P[sku]; return p ? CART.qty(p.variantId) : 0; };
    var setQ = function (sku, n) { var p = P[sku]; if (p) CART.set(p.variantId, n); };

    function up(sku) {
      var p = P[sku]; if (!p || !sellable(sku)) return;
      var q = Q(sku), a = of(sku);
      var n = p.kind === 'single' ? (q === 0 ? Math.max(p.min, p.mult) : q + p.mult) : q + 1;
      if (n > a.max) return;
      setQ(sku, n); say(p.title + ': ' + n + ' in your cart');
    }
    function down(sku) {
      var p = P[sku]; if (!p) return;
      var q = Q(sku);
      var n = p.kind === 'single' ? (q <= Math.max(p.min, p.mult) ? 0 : q - p.mult) : q - 1;
      setQ(sku, Math.max(0, n)); say(p.title + ': ' + (n > 0 ? n + ' in your cart' : 'removed from your cart'));
    }
    function totals() {
      var t = { lines: 0, pieces: 0, offset: 0, sub: 0 };
      Object.keys(P).forEach(function (s) { var p = P[s], q = Q(s); if (!(q > 0)) return; t.lines++; t.pieces += (p.pieces || 1) * q; t.offset += (p.offset || 0) * q; t.sub += (p.price || 0) * q; });
      return t;
    }

    /* ---------- controls ---------- */
    function stepper(sku, wide) {
      var q = Q(sku), a = of(sku);
      return '<span class="woc-stp' + (wide ? ' woc-stp--wide' : '') + '" data-woc-stp="' + esc(sku) + '">' +
        '<button type="button" data-woc-dn="' + esc(sku) + '" aria-label="Fewer">&minus;</button>' +
        '<output aria-live="polite">' + q + '</output>' +
        '<button type="button" data-woc-up="' + esc(sku) + '" aria-label="More"' + (a.max !== Infinity && q >= a.max ? ' disabled' : '') + '>+</button></span>';
    }
    function control(sku, label, wide, variant) {
      var a = of(sku), w = wide ? ' woc-btn--wide' : '';
      if (!signedIn) return '<a class="woc-btn' + w + ' woc-btn--sm" href="' + esc(LOGIN) + '">Login to order</a>';
      if (a.state === 'oos' || a.state === 'unavailable' || a.state === 'hidden')
        return '<button type="button" class="woc-btn' + w + ' woc-btn--sm" disabled>' + (a.state === 'oos' ? 'Out of stock' : 'Unavailable') + '</button>';
      if (Q(sku) > 0) return stepper(sku, wide);
      var v = variant === 'secondary' ? ' woc-btn--secondary' : '';
      return '<button type="button" class="woc-btn' + v + w + ' woc-btn--sm" data-woc-up="' + esc(sku) + '" data-woc-bump>' + esc(label) + '</button>';
    }
    function availLine(sku) {
      var a = of(sku); if (!a.label) return '';
      var cls = a.state === 'oos' ? 'oos' : a.state === 'unavailable' ? 'tmp' : 'low';
      return '<span class="woc-avail woc-avail--' + cls + '">' + esc(a.label) + '</span>';
    }
    function factsOf(sku) {
      var p = P[sku];
      if (p.kind === 'kit') return p.pieces + '-piece assortment &middot; ' + (p.offset ? 'Display + ' + p.offset + ' free offset pieces included' : 'No stand');
      if (p.kind === 'pack') return p.pieces + ' pieces &middot; Two of every color';
      var f = fmtOf[sku];
      return (f ? esc(f.name) + ' &middot; ' : '') + 'Sold in multiples of ' + p.mult;
    }

    /* ---------- main-page cards ---------- */
    function renderCards() {
      root.querySelectorAll('[data-woc-slot]').forEach(function (slot) {
        var sku = slot.dataset.wocSlot; if (!P[sku]) return;
        slot.innerHTML = availLine(sku) + control(sku, slot.dataset.wocLabel || 'Add', true);
        var card = slot.closest('[data-woc-card]'); if (card) card.classList.toggle('is-unavailable', !sellable(sku));
      });
    }

    /* ---------- the drawer: one surface, three modes ---------- */
    var drawer = root.querySelector('[data-woc-drawer]'), scrim = root.querySelector('[data-woc-scrim]');
    var drH = root.querySelector('[data-woc-dr-h]'), drSub = root.querySelector('[data-woc-dr-sub]'), drBody = root.querySelector('[data-woc-dr-body]'),
        drFoot = root.querySelector('[data-woc-dr-foot]'), backBtn = root.querySelector('[data-woc-back]'), backLbl = root.querySelector('[data-woc-back-label]');
    var dr = { open: false, mode: null, sku: null, from: null, img: 0 };
    var activeFmt = FORMATS.length ? FORMATS[0].tag : null;
    var lastFocus = null, scrollY = 0;
    /* on phones the drawer is full-screen, so a second level inside it (pack → detail → Back)
       reads as getting lost; there, a tap on a pack or keychain just enlarges its photo */
    var small = function () { return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; };
    function zoomProduct(sku) {
      var p = P[sku]; if (!p) return;
      var im = p.images.filter(function (x) { return /_ISO/i.test(x.src || ''); })[0] || p.images[0] || {};
      openLb(im.zoom || im.src || p.image, im.alt || p.title);
    }

    function lock(on) {
      if (on) { scrollY = window.scrollY; document.body.style.top = -scrollY + 'px'; document.body.classList.add('woc-locked'); }
      else { document.body.classList.remove('woc-locked'); document.body.style.top = ''; window.scrollTo(0, scrollY); }
    }

    function stylesHtml() {
      return FORMATS.map(function (f) {
        var pk = P[f.pack]; if (!pk) return '';
        return '<div class="woc-pk' + (sellable(f.pack) ? '' : ' is-unavailable') + '">' +
          '<a class="woc-pk__img" href="' + esc(pk.url) + '" data-woc-open="detail" data-woc-sku="' + esc(f.pack) + '">' + img(f.pack, pk.title) + '</a><div>' +
          (f.label ? '<p class="woc-pk__l">' + esc(f.label) + '</p>' : '') +
          '<h3 class="woc-pk__t"><a href="' + esc(pk.url) + '" data-woc-open="detail" data-woc-sku="' + esc(f.pack) + '">' + esc(f.name) + '</a></h3>' +
          (f.blurb ? '<p class="woc-pk__d">' + esc(f.blurb) + '</p>' : '') +
          '<div class="woc-pk__m"><b>' + priceOf(f.pack) + '</b><span>' + (pk.pieces || 12) + ' pieces</span></div>' +
          availLine(f.pack) + control(f.pack, L.addPack || 'Add this pack', true) + '</div></div>';
      }).join('');
    }
    function tabsHtml() {
      return '<div class="woc-tabs"><div class="woc-tabs__in" role="tablist" aria-label="Keychain style">' + FORMATS.map(function (f) {
        var n = COLORS.reduce(function (a, c) { var s = find(c.key, f.tag); return a + (s ? Q(s) : 0); }, 0);
        return '<button type="button" role="tab" data-woc-tab="' + esc(f.tag) + '" aria-selected="' + (f.tag === activeFmt) + '">' +
          '<span class="woc-tabs__n">' + esc(f.name) + (n > 0 ? ' <em>&middot; ' + n + '</em>' : '') + '</span>' +
          (f.label ? '<span class="woc-tabs__l">' + esc(f.label) + '</span>' : '') + '</button>';
      }).join('') + '</div></div>';
    }
    function palHtml() {
      var f = FORMATS.filter(function (x) { return x.tag === activeFmt; })[0]; if (!f) return '';
      return '<div class="woc-pal">' + COLORS.map(function (c) {
        var sku = find(c.key, f.tag);
        if (!sku) return '<div class="woc-pc"><div class="woc-pc__img"></div><div class="woc-pc__b"><div class="woc-pc__n">' + chip(c.sw, true) + '<b>' + esc(c.key) + '</b></div><span class="woc-avail woc-avail--oos">Not made in this style</span></div></div>';
        var a = of(sku); if (a.state === 'hidden') return '';
        return '<div class="woc-pc' + (sellable(sku) ? '' : ' is-unavailable') + '"><a class="woc-pc__img" href="' + esc(P[sku].url) + '" data-woc-open="detail" data-woc-sku="' + esc(sku) + '">' + img(sku, c.key + ' ' + f.name) + '</a>' +
          '<div class="woc-pc__b"><div class="woc-pc__n">' + chip(c.sw, true) + '<b>' + esc(c.key) + '</b></div>' +
          '<p class="woc-pc__p">' + priceOf(sku) + '</p>' + availLine(sku) + control(sku, L.add || 'Add', true, 'secondary') + '</div></div>';
      }).join('') + '</div>';
    }
    function detailHtml(sku) {
      var p = P[sku]; if (!p) return '';
      var imgs = p.images, i = Math.min(dr.img, imgs.length - 1), cur = imgs[i] || {};
      var eyebrow = p.kind === 'kit' ? 'Display-ready' : p.kind === 'pack' ? 'Variety pack' : (fmtOf[sku] ? fmtOf[sku].label || fmtOf[sku].name : 'Keychain');
      return '<div class="woc-det__img"><button type="button" data-woc-zoom="' + esc(cur.zoom || cur.src || p.image) + '" aria-label="Enlarge image"><img src="' + esc(cur.src || p.image) + '" alt="' + esc(cur.alt || p.title) + '"></button></div>' +
        (imgs.length > 1 ? '<div class="woc-det__thumbs">' + imgs.map(function (im, j) { return '<button type="button" data-woc-img="' + j + '" aria-current="' + (j === i) + '" aria-label="Image ' + (j + 1) + '"><img src="' + esc(im.src) + '" alt=""></button>'; }).join('') + '</div>' : '') +
        '<p class="woc-det__l">' + esc(eyebrow) + '</p>' +
        '<h3 class="woc-det__n">' + esc(p.title) + '</h3>' +
        '<p class="woc-det__f">' + factsOf(sku) + '</p>' +
        '<p class="woc-det__sku">' + esc(p.sku) + '</p>' +
        '<div class="woc-det__buy"><span class="woc-det__p">' + priceOf(sku) + '</span><span>' + availLine(sku) + control(sku, p.kind === 'single' ? (L.add || 'Add') : (L.addKit || 'Add to cart'), false) + '</span></div>' +
        (p.descriptionHtml ? '<p class="woc-det__h">About</p><div class="woc-det__desc">' + p.descriptionHtml + '</div>' : '') +
        '<p class="woc-det__view"><a class="woc-link" href="' + esc(p.url) + '">View product page &rarr;</a></p>';
    }

    function renderDrawer() {
      if (!dr.open) return;
      var wide = dr.mode === 'refill';
      drawer.classList.toggle('woc-drawer--wide', wide);
      backBtn.hidden = !dr.from;
      if (dr.from) backLbl.textContent = dr.from === 'styles' ? (L.backStyles || 'Back to styles') : (L.backRefill || 'Back to colors');
      drFoot.hidden = true; drFoot.innerHTML = '';
      if (dr.mode === 'styles') {
        drH.textContent = L.stylesHeading || 'Choose a keychain style'; drSub.textContent = L.stylesText || '';
        drBody.innerHTML = stylesHtml();
        if (L.refillLink) { drFoot.hidden = false; drFoot.innerHTML = '<button type="button" class="woc-link" data-woc-open="refill">' + esc(L.refillLink) + '&nbsp;&rarr;</button>'; }
      } else if (dr.mode === 'refill') {
        drH.textContent = L.refillHeading || 'Build a custom refill'; drSub.textContent = L.refillText || '';
        drBody.innerHTML = tabsHtml() + palHtml();
      } else if (dr.mode === 'detail' && P[dr.sku]) {
        var p = P[dr.sku];
        drH.textContent = p.kind === 'single' ? (fmtOf[dr.sku] ? fmtOf[dr.sku].name : 'Keychain') : (p.kind === 'pack' ? 'Variety pack' : 'Display-ready');
        drSub.textContent = '';
        drBody.innerHTML = detailHtml(dr.sku);
      }
    }
    function openDrawer(mode, sku) {
      var wasOpen = dr.open;
      if (mode === 'detail') { dr.from = wasOpen && dr.mode !== 'detail' ? dr.mode : (wasOpen ? dr.from : null); }
      else dr.from = null;
      dr.open = true; dr.mode = mode; dr.sku = sku || null; dr.img = 0;
      /* open on the isolated cutout, matching the card that led here; the propped shot stays a thumbnail */
      if (mode === 'detail' && P[sku]) { var iso = P[sku].images.findIndex(function (im) { return /_ISO/i.test(im.src || ''); }); if (iso > 0) dr.img = iso; }
      if (!wasOpen) { lastFocus = document.activeElement; lock(true); drawer.hidden = false; }
      renderDrawer();
      drBody.scrollTop = 0;
      if (!wasOpen) requestAnimationFrame(function () { drawer.classList.add('on'); scrim.classList.add('on'); });
      setTimeout(function () { var c = drawer.querySelector('.woc-ovclose'); if (c) c.focus(); }, 40);
    }
    function closeDrawer() {
      if (!dr.open) return;
      dr.open = false;
      drawer.classList.remove('on'); scrim.classList.remove('on');
      setTimeout(function () { if (!dr.open) drawer.hidden = true; }, 340);
      lock(false);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    /* ---------- lightbox ---------- */
    var lb = root.querySelector('[data-woc-lb]'), lbImg = root.querySelector('[data-woc-lb-img]'), lbFocus = null;
    function openLb(src, alt) { if (!lb) return; lbFocus = document.activeElement; lbImg.src = src; lbImg.alt = alt || ''; lb.hidden = false; if (!dr.open) lock(true); setTimeout(function () { var x = lb.querySelector('[data-woc-lb-close]'); if (x) x.focus(); }, 30); }
    function closeLb() { if (!lb || lb.hidden) return; lb.hidden = true; lbImg.src = ''; if (!dr.open) lock(false); if (lbFocus && document.contains(lbFocus)) lbFocus.focus(); }

    function render() { renderCards(); renderDrawer(); }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button, a'); if (!b || !root.contains(b)) return;
      var d = b.dataset;
      if (d.wocUp !== undefined) { e.preventDefault(); up(d.wocUp); render(); if (d.wocBump !== undefined) { say(P[d.wocUp].title + ' added to your cart'); toast('<b>' + esc(P[d.wocUp].title) + '</b> added to your cart.' + cartLink, 4000); } return; }
      if (d.wocDn !== undefined) { e.preventDefault(); down(d.wocDn); render(); return; }
      if (d.wocCart !== undefined) { e.preventDefault(); CART.open(); return; }
      if (d.wocOpen !== undefined) { e.preventDefault(); if (d.wocOpen === 'detail' && dr.open && small()) { zoomProduct(d.wocSku); return; } openDrawer(d.wocOpen, d.wocSku); return; }
      if (d.wocBack !== undefined) { var to = dr.from || 'styles'; dr.from = null; openDrawer(to); return; }
      if (d.wocClose !== undefined) { closeDrawer(); return; }
      if (d.wocTab !== undefined) { activeFmt = d.wocTab; renderDrawer(); return; }
      if (d.wocImg !== undefined) { dr.img = +d.wocImg; renderDrawer(); return; }
      if (d.wocZoom !== undefined) { e.preventDefault(); var im = b.querySelector('img'); openLb(d.wocZoom, im ? im.alt : ''); return; }
      if (d.wocLbClose !== undefined) { closeLb(); return; }
    });
    if (scrim) scrim.addEventListener('click', function () { closeDrawer(); });
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (CART.drawerOpen()) return; /* the theme's cart drawer is on top: its keys are its own */
      if (e.key === 'Escape') { if (lb && !lb.hidden) closeLb(); else if (dr.open) closeDrawer(); return; }
      if (e.key === 'Tab') {
        var box = lb && !lb.hidden ? lb : (dr.open ? drawer : null); if (!box) return;
        var f = Array.prototype.filter.call(box.querySelectorAll('button:not(:disabled),[href],[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !box.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });
    /* the cart is the state: re-render whenever it changes, tell the buyer when it refuses */
    CART.on(function () { render(); });
    CART.onError(function (msg) { toast(esc(msg)); say(msg); });
    render();
    CART.load();

    /* deep links from the homepage: #styles opens the four styles, #refill opens the builder */
    function deepLink() { var h = (location.hash || '').replace(/^#/, ''); if (h === 'styles' || h === 'refill') openDrawer(h); }
    setTimeout(deepLink, 150);
    window.addEventListener('hashchange', deepLink);
  }

  function boot() { document.querySelectorAll('[data-woc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-woc]'); if (r) init(r); });
})();
